// Change archive-specific behavior here when turning the recovered site into your own homepage.
export const siteConfig = {
  originalOrigin: "https://mimo.mi.com",
  externalizeNavigation: true,
  localRoutes: ["/"],
  hero: {
    poster: "images/hero-lotus-poster.png",
    mobilePoster: "images/hero-lotus-poster.png",
    video: "videos/petals-preview.mp4",
  },
  localVideoOnly: true,
  availableVideos: ["videos/petals-preview.mp4"],
  videoPlaceholder: "/offline/video.svg",
};
